<template>
  <div class="channel-item">
    <div class="left">
      <h3-title :icon="channel.icon">
        {{ channel.title }}
      </h3-title>
      <p class="secondary">{{ channel.info }}</p>
      <p class="status" v-if="!channel.status">未开通</p>
    </div>
    <div :class="!channel.status ? 'right right-bg' : 'right'"><img :src="channel.typeImage" alt="" /></div>
  </div>
</template>

<script>
import h3Title from './h3-title.vue';
export default {
  name: 'channelItem',
  components: { h3Title },
  props: {
    channel: Object,
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.h3,
.secondary {
  margin: 0;
}
.channel-item {
  width: 260px;
  height: 90px;
  margin-top: 20px;
  margin-right: 20px;
  padding: 20px 20px 10px 20px;
  border: 1px solid #dddfe3;
  border-radius: 5px;
  cursor: pointer;
  .flex_layout(row, space-between);
}
.right img {
  margin-top: -10px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.right-bg img {
  opacity: 0.75;
}
.left {
  height: 100%;
  // .flex_layout(column, space-between, flex-start);
  .h3 {
    .flex_layout(row, flex-start);
    font-weight: 400;
    .img {
      margin-right: 0.3em;
      font-size: 18px;
      color: @font-color-black;
      // margin-right: 10px;
    }
  }
  .secondary {
    color: @font-color-secondary;
    margin: 20px 0 15px;
  }
}
.status {
  width: 56px;
  height: 19px;
  border: 1px solid #ff5f5f;
  border-radius: 10px;
  font-size: 12px;
  color: #ff5f5f;
  line-height: 19px;
  text-align: center;
}
</style>
